import { useState, useEffect } from "react";
import NiceModal, { useModal, bootstrapDialog } from "@ebay/nice-modal-react";
import BootstrapModal from "react-bootstrap/Modal";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import React from "react";
import { toast } from "react-toastify";
import { instance } from "../axios";
import { useNavigate, useParams } from "react-router-dom";
import { UiSelect, UiInput, OverlayLoader, UiButton, titleCase, UiTextArea, UiUserSelect, UiDatePicker } from "../ui";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useStore } from "../state.js";
import { notification, Flex, Spin  } from "antd";
import { setStorage, getStorage } from "../helper.js";
import imageCompression from 'browser-image-compression';
import { IoMdClose } from "react-icons/io";
import { set } from "date-fns";


const Job = NiceModal.create(
  ({ id }) => {
    const [state, setState] = useState({ count: 0 });

    const [originalImages, setOriginalImages] = useState([]);
    const [compressedImages, setCompressedImages] = useState([]);
    const [uploadedImages, setUploadedImages] = useState([]);
    const [allImages, setAllImages] = useState([]);
    const [deletedImages, setDeletedImages] = useState([]);
    const [error, setError] = useState('');
    const [init_load, setInitLoad] = useState(false);


    const modal = useModal();

    const schema = yup.object().shape({
      name: yup.string().required("Enter name"),
      city: yup.string().required("Enter city"),
      item: yup.string().required("Enter item"),
      status: yup.string().required("Select status"),



    }, []);
    const {
      register,
      handleSubmit,
      control,
      watch,
      unregister,
      setValue,
      formState: { errors },
      reset,
    } = useForm({
      resolver: yupResolver(schema),
    });
    const onSubmitHandler = async (data) => {
      SaveTag(data);
      //reset();
    };
    var SaveTag = (e) => {
      setState({ ...state, loader: true });
      var form = document.querySelector("#jobform");
      var data = new FormData(form);
      compressedImages.forEach((img, index) => {
        data.append(`photos[${index}]`, img.file);
      });
      data.append('deleted_images', JSON.stringify(deletedImages));
      instance({
        method: id == "new" ? "post" : "post",
        url: "/jobs" + (id == "new" ? "" : "/" + id),
        data: data,
        headers: { "Content-Type": "multipart/form-data", 'X-HTTP-Method-Override': id == "new" ? '' : 'PUT', },
      })
        .then(function (response) {
          setState({ ...state, loader: false });
          if (response.status == 200 || response.status == 201) {
            toast(response.data.message, { type: "success" });
            modal.resolve({ resolved: true });
            modal.hide();
          }
          if (response.data.status == "success") {
            useStore.setState({ load_projects: false });
            toast(response.data.msg, { type: "success" });
            modal.resolve({ resolved: true });
            modal.hide();
          }
        })
        .catch(function (response) { });
    };



    const fetchData = () => {
      instance
        .get("/jobs/" + id + "")
        .then(function (response) {
          setState(response.data)
          if (id == 'new') {
            //reset({ ...response.data.data })
          } else {
            reset(response.data.data)
            setUploadedImages(response.data.data.photos)
            setInitLoad(true)
          }

        })
        .catch(function (error) { })
        .then(function () { });
    }


    useEffect(() => {
if(id != 'new'){
      fetchData()
} else {
  setInitLoad(true)
}

    }, []);

    useEffect(() => {

      setAllImages([...compressedImages, ...uploadedImages])

    }, [compressedImages, uploadedImages]);



    const handleFileChange = async (event) => {
      const files = event.target.files;
      if (!files || files.length === 0) return;

      try {
        setError('');
        const compressed = [];
        const originals = [];
        const compressionOptions = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };

        for (const file of files) {
          originals.push(URL.createObjectURL(file));
          const compressedFile = await imageCompression(file, compressionOptions);
          compressed.push({ file: compressedFile, preview: URL.createObjectURL(compressedFile) });
        }

        setOriginalImages(originals);
        setCompressedImages(compressed);
      } catch (err) {
        setError('Failed to compress images. Please try again.');
        console.error(err);
      }
    };




    const handleHide = () => {
      modal.hide();
    }


    const handleRemove = (i, type) => {
      if (type == 'uploaded') {
        const arr = uploadedImages.filter((item, index) => index !== i);
        setDeletedImages([...deletedImages, uploadedImages[i].file]);
        setUploadedImages(arr);
      } else if (type == 'selected') {
        const arr = compressedImages.filter((item, index) => index !== i);
        setCompressedImages(arr);
      }
    }



    return (
      <BootstrapModal {...bootstrapDialog(modal)} onHide={() => handleHide()}>
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>Job</BootstrapModal.Title>
        </BootstrapModal.Header>
        <OverlayLoader visible={state.loader} />
        <BootstrapModal.Body>
          {init_load ?
          <form id="jobform" onSubmit={handleSubmit(onSubmitHandler)}>
            <div className="row">
              <div className="col">
                <UiInput
                  label="Name"
                  type="text"
                  required
                  name="name"
                  {...register("name", { onBlur: (e) => setValue('name', titleCase(e.target.value)) })}
                  message={errors.name?.message}
                />
              </div>
              <div className="col">
                <UiInput
                  label="Mobile"
                  type="text"
                  required
                  name="mobile"
                  {...register("mobile")}
                  message={errors.mobile?.message}
                />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <UiInput
                  label="City"
                  type="text"
                  required
                  name="city"
                  {...register("city")}
                  message={errors.city?.message}
                />

              </div>
              <div className="col">
                <UiInput
                  label="Item"
                  type="text"
                  required
                  name="item"
                  {...register("item")}
                  message={errors.item?.message}
                />

              </div>
            </div>
            <div className="row">
              <div className="col">

                <UiInput
                  label="Estimate"
                  type="text"
                  name="estimate"
                  {...register("estimate")}
                  message={errors.estimate?.message}
                />
              </div>
              <div className="col">
                <UiInput
                  label="Time Period"
                  type="text"
                  name="estimate_time"
                  {...register("estimate_time")}
                  message={errors.estimate_time?.message}
                />
              </div>
            </div>


            <UiSelect
              label='Status'
              required
              name="status"
              message={errors.status?.message}
              options={["Pending", "Completed", "Hold", "Delivered", "ServiceCenter"]}
              {...register(`status`)}
            />

            <UiTextArea

              label="Problem"
              name="problem"
              message={errors.problem?.message}
              {...register("problem")}
            />
            <div className="d-block">
              <label className="form-label">Photos</label>
              <input
                className="form-control"
                type="file"
                accept="image/*"
                multiple
                capture="environment"
                onChange={handleFileChange}
              //disabled={loading}
              />
            </div>
            {allImages.length > 0 && (
              <div style={{ marginTop: '20px' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                  {uploadedImages.map((img, index) => (
                    <div className="position-relative">
                      <img
                        key={index}
                        src={img.preview}
                        alt={`Compressed ${index + 1}`}
                        style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                      />
                      <button onClick={() => handleRemove(index, 'uploaded')} type="button" className="btn btn-outline-danger text-danger position-absolute top-0 end-0 border-0 bg-white" ><IoMdClose /></button>
                    </div>
                  ))}
                  {compressedImages.map((img, index) => (
                    <div className="position-relative">
                      <img
                        key={index}
                        src={img.preview}
                        alt={`Compressed ${index + 1}`}
                        style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                      />
                      <button onClick={() => handleRemove(index, 'selected')} type="button" className="btn btn-outline-danger text-danger position-absolute top-0 end-0 border-0 bg-white" ><IoMdClose /></button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <UiButton className="btn btn-primary mt-4" type="submit" title="Save" />

          </form>
          :
          <Flex gap="middle" justify="center">
          <Flex gap="middle">
            <Spin tip="Loading" size="small">
            </Spin>
           
          </Flex>
   
        </Flex>}
        </BootstrapModal.Body>

      </BootstrapModal>
    );
  }
);

export default Job;
